import { trackEvent } from 'services/Analytics';

export const trackCancelSubscriptionRequest = () => trackEvent('front_cancel_subscription_request');
